export const categories = [
  {
    slug: 'yiqu',
    name: '精品一区',
    description: '精选深度内容，涵盖科技前沿、商业洞察、人文思考等领域的高品质原创文章，为您提供最具价值的知识阅读体验。',
    icon: 'ri-star-line',
    color: 'primary',
    articleCount: 42,
  },
  {
    slug: 'ercu',
    name: '精品二区',
    description: '优质生活内容，聚焦健康养生、旅行探索、美食文化、艺术设计等生活美学领域的精选内容，丰富您的品质生活。',
    icon: 'ri-heart-line',
    color: 'accent',
    articleCount: 38,
  },
];

export const articles = [
  {
    id: 'article-1',
    slug: 'rengongzhineng-2026-qushi',
    title: '2026年人工智能发展趋势：从大模型到通用智能的演进之路',
    excerpt: '深入分析2026年AI领域最新动态，探讨大语言模型如何向通用人工智能迈进，以及产业落地的关键突破点。',
    content: `
      <p>在过去的两年里，人工智能领域经历了前所未有的变革。从GPT系列到各类国产大模型的涌现，AI技术正以惊人的速度改变着我们的世界。</p>
      
      <h2>一、大模型技术的持续突破</h2>
      <p>2026年，大语言模型已经不再是简单的文本生成工具。多模态能力的深度融合使得AI能够同时理解文字、图像、音频甚至视频内容。这种跨模态的理解能力让AI在复杂场景中的应用变得更加自然和高效。</p>
      <p>值得关注的是，模型效率的提升使得AI部署成本大幅下降。边缘计算与云计算的协同工作模式，让高性能AI不再局限于数据中心，而是走向了移动设备和物联网终端。</p>
      
      <h2>二、行业应用的深度渗透</h2>
      <p>在医疗健康领域，AI辅助诊断系统已覆盖超过200种常见疾病，准确率达到专家级水平。在金融行业，智能风控和量化交易系统正在重塑整个行业的运作模式。教育领域的个性化学习助手让因材施教从理念变成了现实。</p>
      
      <h2>三、通用人工智能的探索</h2>
      <p>虽然距离真正的通用人工智能还有很长的路要走，但研究者们在推理能力、规划能力和自主学习能力方面取得了令人瞩目的进展。新型神经网络架构和训练范式的创新正在逐步缩小专用AI与通用AI之间的差距。</p>
      
      <h2>四、伦理与治理的挑战</h2>
      <p>随着AI技术的深入应用，数据隐私、算法偏见、就业影响等伦理问题也日益凸显。各国政府和国际组织正在积极推进AI治理框架的建设，以确保技术发展惠及全人类。</p>
      
      <p>展望未来，人工智能将继续以不可阻挡的势头向前发展。对于企业和个人而言，拥抱AI、理解AI、善用AI，将是2026年及以后最重要的课题之一。</p>
    `,
    category: 'yiqu',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20artificial%20intelligence%20concept%20with%20glowing%20neural%20networks%20and%20digital%20brain%20on%20minimal%20warm%20toned%20background%2C%20clean%20tech%20aesthetic%2C%20soft%20golden%20accents%2C%20editorial%20style%20with%20abstract%20data%20visualization%20elements&width=800&height=500&seq=article-ai-2026&orientation=landscape',
    author: '张明远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20attire%20on%20clean%20warm%20beige%20background%2C%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20editorial%20headshot%20style&width=100&height=100&seq=author-zhang&orientation=squarish',
    date: '2026-08-05',
    readTime: '12分钟',
    tags: ['人工智能', '科技趋势', '深度学习', '行业分析'],
    featured: true,
  },
  {
    id: 'article-2',
    slug: 'jiankang-shenghuo-yinshi-zhinan',
    title: '科学饮食指南：2026年最值得关注的健康饮食趋势与营养搭配法则',
    excerpt: '从地中海饮食到植物基革命，全面解读2026年全球健康饮食新风尚，为您打造科学合理的日常膳食方案。',
    content: `
      <p>健康饮食始终是人们关注的焦点。随着营养科学研究的不断深入，2026年的健康饮食理念正在发生深刻的变化。</p>
      
      <h2>一、个性化营养的崛起</h2>
      <p>基于肠道微生物组检测的个性化营养方案正在成为主流。通过分析个体的肠道菌群构成，营养师可以为每个人量身定制最适合的饮食方案。这种精准营养的方法已经在改善代谢健康方面取得了显著成效。</p>
      
      <h2>二、植物基饮食的持续进化</h2>
      <p>植物基食品不再只是素食者的选择。新一代植物基产品的口感和营养价值已经能够媲美甚至超越传统动物源食品。从植物肉到植物奶，这个市场正在经历爆发式增长。</p>
      
      <h2>三、功能性食品的新浪潮</h2>
      <p>富含益生菌、后生元、适应原等功能性成分的食品正在成为日常饮食的重要组成部分。这些食品不仅提供基础营养，还能主动调节身体机能，提升免疫力。</p>
      
      <h2>四、可持续饮食理念</h2>
      <p>环保意识的提升使得可持续饮食成为重要趋势。减少食物浪费、选择本地当季食材、降低碳足迹等理念正在影响越来越多消费者的饮食选择。</p>
      
      <p>健康饮食不是一蹴而就的事情，而是一种需要长期坚持的生活方式。从今天开始，逐步调整您的饮食结构，让健康成为习惯。</p>
    `,
    category: 'ercu',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20healthy%20food%20arrangement%20with%20fresh%20vegetables%20fruits%20and%20grains%20on%20warm%20wooden%20table%2C%20natural%20sunlight%2C%20minimal%20composition%2C%20warm%20earthy%20tones%2C%20clean%20food%20photography%20style&width=800&height=500&seq=article-health-diet&orientation=landscape',
    author: '李雅文',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20casual%20attire%20on%20clean%20warm%20beige%20background%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20editorial%20headshot%20style&width=100&height=100&seq=author-li&orientation=squarish',
    date: '2026-08-03',
    readTime: '8分钟',
    tags: ['健康饮食', '营养科学', '生活方式', '养生指南'],
    featured: true,
  },
  {
    id: 'article-3',
    slug: 'shuzi-jingji-zhuanxing',
    title: '数字化转型2.0：企业如何在智能经济时代构建核心竞争力',
    excerpt: '探讨企业数字化转型的下一阶段，从技术架构到组织变革，全方位解析智能经济时代的制胜策略。',
    content: `
      <p>数字化转型已经进入2.0时代。如果说1.0阶段的核心是将业务流程数字化，那么2.0阶段的关键则是用数据和智能重塑整个商业模式。</p>
      
      <h2>一、数据驱动决策体系</h2>
      <p>在数字化转型2.0时代，数据不再只是辅助工具，而是企业决策的核心驱动力。实时数据分析平台、预测性分析模型和智能决策支持系统正在成为企业标配。</p>
      
      <h2>二、智能工作流的构建</h2>
      <p>AI驱动的自动化工作流正在彻底改变企业的运营方式。从客户服务到供应链管理，从财务核算到人力资源管理，智能自动化正在释放巨大的效率红利。</p>
      
      <h2>三、组织文化的重塑</h2>
      <p>技术转型只是手段，组织和文化的变革才是数字化转型成功的关键。建立学习型组织、培养数字素养、鼓励创新试错，这些软性因素往往决定了转型的成败。</p>
      
      <p>数字化转型是一场没有终点的马拉松。企业需要持续学习和适应，才能在智能经济时代保持竞争力。</p>
    `,
    category: 'yiqu',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20transformation%20concept%20with%20abstract%20data%20flows%20and%20business%20strategy%20visualization%2C%20warm%20golden%20and%20neutral%20tones%2C%20clean%20corporate%20aesthetic%2C%20professional%20editorial%20style&width=800&height=500&seq=article-digital-trans&orientation=landscape',
    author: '王建国',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20middle%20aged%20in%20business%20attire%20on%20clean%20warm%20beige%20background%2C%20confident%20expression%2C%20soft%20natural%20lighting%2C%20editorial%20headshot&width=100&height=100&seq=author-wang&orientation=squarish',
    date: '2026-08-01',
    readTime: '10分钟',
    tags: ['数字化转型', '企业管理', '智能经济', '商业策略'],
    featured: true,
  },
  {
    id: 'article-4',
    slug: 'lvyou-tansuo-yunnan',
    title: '云南秘境之旅：探索茶马古道上的隐世小镇与绝美风光',
    excerpt: '跟随作者的步伐，深入云南腹地，探访那些鲜为人知的古镇村落，感受千年茶马古道的文化魅力与自然奇观。',
    content: `
      <p>云南，这片神奇的土地，总是能给人带来无尽的惊喜。在热门景点之外，隐藏着许多不为人知的秘境，保留着最原汁原味的自然风光和人文气息。</p>
      
      <h2>一、沙溪古镇：时光凝固的茶马驿站</h2>
      <p>位于大理和丽江之间的沙溪古镇，是茶马古道上保存最完整的古集市。青石板路、木质老屋、潺潺溪流，这里的一切都仿佛停留在数百年前。</p>
      
      <h2>二、诺邓古村：盐井孕育的千年文明</h2>
      <p>诺邓因盐而兴，因盐而名。这个坐落在云龙县的古村落，有着上千年历史的盐井和保存完好的明清建筑群。诺邓火腿更是闻名遐迩的美食。</p>
      
      <h2>三、普者黑：喀斯特地貌上的田园诗画</h2>
      <p>普者黑的山水之美令人窒息。碧波荡漾的湖泊、形态各异的峰林、错落有致的田园，构成了一幅动人的山水画卷。夏季荷花盛开时节，更是美不胜收。</p>
      
      <p>旅行不只是看风景，更是感受不同生活方式的过程。在这些隐世小镇中，您能找回内心最纯粹的宁静。</p>
    `,
    category: 'ercu',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20ancient%20Chinese%20town%20in%20Yunnan%20with%20traditional%20wooden%20architecture%20stone%20paths%20and%20misty%20mountains%2C%20warm%20golden%20sunlight%2C%20serene%20atmosphere%2C%20travel%20photography%20style%20with%20rich%20earthy%20tones&width=800&height=500&seq=article-yunnan-travel&orientation=landscape',
    author: '陈思雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20young%20in%20casual%20travel%20attire%20on%20clean%20warm%20beige%20background%2C%20bright%20smile%2C%20soft%20natural%20lighting%2C%20editorial%20headshot&width=100&height=100&seq=author-chen&orientation=squarish',
    date: '2026-07-28',
    readTime: '9分钟',
    tags: ['旅行探索', '云南秘境', '茶马古道', '古镇文化'],
    featured: false,
  },
  {
    id: 'article-5',
    slug: 'qukuailian-jishu-jinrong',
    title: '区块链3.0：去中心化金融如何重塑全球金融基础设施',
    excerpt: '深度解析区块链技术在金融领域的最新应用，从DeFi到CBDC，探讨去中心化技术对传统金融体系的深远影响。',
    content: `
      <p>区块链技术已经从加密货币的底层技术，发展成为能够重塑整个金融体系的基础设施。2026年，我们正在见证区块链3.0时代的到来。</p>
      
      <h2>一、DeFi的成熟与演进</h2>
      <p>去中心化金融已经从实验阶段走向成熟。总锁仓价值突破万亿美元大关，各类DeFi协议在借贷、交易、保险、衍生品等领域的应用日益完善。</p>
      
      <h2>二、CBDC的全球竞赛</h2>
      <p>全球超过100个国家和地区正在探索或试点央行数字货币。数字人民币的推广走在前列，已在多个场景实现大规模应用。</p>
      
      <h2>三、跨链互操作性的突破</h2>
      <p>跨链技术的发展使得不同区块链之间的资产和数据流动变得更加顺畅。这将催生更加复杂和强大的去中心化应用生态。</p>
      
      <p>区块链3.0的核心价值在于构建一个更加开放、透明、高效的金融基础设施。这不仅是技术革新，更是金融民主化的重要一步。</p>
    `,
    category: 'yiqu',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20blockchain%20technology%20concept%20with%20interconnected%20glowing%20nodes%20and%20digital%20ledger%20visualization%2C%20warm%20amber%20and%20golden%20tones%2C%20clean%20futuristic%20aesthetic%2C%20financial%20technology%20editorial%20style&width=800&height=500&seq=article-blockchain&orientation=landscape',
    author: '赵天宇',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20young%20in%20tech%20casual%20attire%20on%20clean%20warm%20beige%20background%2C%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20editorial%20headshot&width=100&height=100&seq=author-zhao&orientation=squarish',
    date: '2026-07-25',
    readTime: '11分钟',
    tags: ['区块链', '金融科技', 'DeFi', '数字货币'],
    featured: false,
  },
  {
    id: 'article-6',
    slug: 'yishu-sheji-jianji-meixue',
    title: '极简主义设计哲学：少即是多的生活美学与空间营造艺术',
    excerpt: '从包豪斯到当代设计，探讨极简主义如何影响我们的居住空间和生活方式，以及如何将简约美学融入日常。',
    content: `
      <p>"少即是多"——这句由建筑大师密斯·凡德罗提出的名言，至今仍是极简主义设计的核心理念。在物质极度丰富的今天，极简主义提供了一种回归本质的生活态度。</p>
      
      <h2>一、极简主义的哲学根基</h2>
      <p>极简主义不仅仅是一种设计风格，更是一种生活哲学。它提倡去除多余，保留本质，让真正重要的东西浮现出来。这种理念源自东方的禅宗思想，也吸收了西方现代主义的理性精神。</p>
      
      <h2>二、空间营造的极简法则</h2>
      <p>在室内设计中，极简主义强调空间的呼吸感。留白不是空洞，而是给生活留出余地。每一件家具、每一处装饰都应该有其存在的意义。</p>
      
      <h2>三、数字生活的极简实践</h2>
      <p>在信息过载的时代，数字极简主义同样重要。减少不必要的应用通知、定期清理数字文件、有意识地控制屏幕时间，这些都是数字极简的具体实践。</p>
      
      <p>极简不是匮乏，而是富足的另一种形式。当您学会舍弃多余的，才能真正拥有最重要的。</p>
    `,
    category: 'ercu',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20interior%20design%20with%20clean%20lines%20warm%20wood%20textures%20and%20soft%20natural%20light%2C%20Japanese%20Scandinavian%20fusion%20aesthetic%2C%20serene%20atmosphere%2C%20warm%20neutral%20tones%2C%20architectural%20photography%20style&width=800&height=500&seq=article-minimal-design&orientation=landscape',
    author: '林若曦',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20young%20in%20artistic%20attire%20on%20clean%20warm%20beige%20background%2C%20gentle%20expression%2C%20soft%20natural%20lighting%2C%20editorial%20headshot&width=100&height=100&seq=author-lin&orientation=squarish',
    date: '2026-07-22',
    readTime: '7分钟',
    tags: ['极简主义', '空间设计', '生活美学', '家居装饰'],
    featured: false,
  },
  {
    id: 'article-7',
    slug: 'xinnengyuan-chanye-geju',
    title: '全球新能源产业格局重塑：储能技术与光伏革命的交汇点',
    excerpt: '分析全球能源转型最新态势，聚焦储能技术突破与光伏产业升级，展望未来清洁能源的发展路径。',
    content: `
      <p>全球能源转型正在加速推进。2026年，新能源产业格局正在经历深刻的重塑，储能技术与光伏革命的交汇正在催生全新的能源生态。</p>
      
      <h2>一、光伏产业的技术迭代</h2>
      <p>钙钛矿太阳能电池的效率已经突破33%，接近理论极限。叠层电池技术的商业化正在推动光伏发电成本进一步降低。中国光伏产业在全球市场的主导地位进一步巩固。</p>
      
      <h2>二、储能技术的重大突破</h2>
      <p>固态电池、液流电池、压缩空气储能等多种储能技术路线百花齐放。储能成本的持续下降使得可再生能源的间歇性问题正在得到有效解决。</p>
      
      <h2>三、新型电力系统的构建</h2>
      <p>以新能源为主体的新型电力系统正在形成。虚拟电厂、智能微电网、需求侧响应等创新模式正在改变传统的电力生产和消费方式。</p>
      
      <p>能源转型不仅是技术问题，更是一场深刻的社会变革。清洁、高效、可持续的能源未来正在向我们走来。</p>
    `,
    category: 'yiqu',
    image: 'https://readdy.ai/api/search-image?query=Modern%20renewable%20energy%20landscape%20with%20solar%20panels%20and%20energy%20storage%20systems%2C%20clean%20futuristic%20aesthetic%2C%20warm%20sunset%20tones%2C%20sustainable%20technology%20concept%2C%20editorial%20photography%20style&width=800&height=500&seq=article-new-energy&orientation=landscape',
    author: '张明远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20attire%20on%20clean%20warm%20beige%20background%2C%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20editorial%20headshot%20style&width=100&height=100&seq=author-zhang&orientation=squarish',
    date: '2026-07-18',
    readTime: '10分钟',
    tags: ['新能源', '储能技术', '光伏产业', '能源转型'],
    featured: true,
  },
  {
    id: 'article-8',
    slug: 'meishi-wenhua-chuancheng',
    title: '舌尖上的传承：中国传统美食文化的现代演绎与创新融合',
    excerpt: '探寻中国传统美食在现代语境下的传承与创新，从宫廷御膳到街头小吃，感受中华饮食文化的博大精深。',
    content: `
      <p>中华美食文化源远流长，每一道经典菜肴背后都蕴藏着深厚的文化底蕴和历史故事。在全球化浪潮中，传统美食正在以全新的面貌走向世界。</p>
      
      <h2>一、传统技艺的现代传承</h2>
      <p>从刀工到火候，从调味到摆盘，中国传统烹饪技艺中蕴含着数千年积累的智慧。越来越多的年轻厨师正在用现代视角重新诠释这些古老技艺。</p>
      
      <h2>二、地方美食的文化价值</h2>
      <p>每一种地方美食都是当地地理环境、历史文化和生活方式的具体体现。保护和传承地方美食，就是在守护中华民族的文化多样性。</p>
      
      <h2>三、中西融合的创新实践</h2>
      <p>在新派中餐的探索中，越来越多的大厨尝试将西方烹饪技法与中国传统食材和调味理念相结合，创造出令人耳目一新的美食体验。</p>
      
      <p>美食是文化最直接的载体。品味一道佳肴，就是在阅读一个文明的故事。</p>
    `,
    category: 'ercu',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20cuisine%20presentation%20with%20traditional%20dishes%20on%20ceramic%20tableware%2C%20warm%20ambient%20lighting%2C%20rich%20textures%20and%20colors%2C%20food%20photography%20style%20with%20cultural%20artistic%20elements&width=800&height=500&seq=article-food-culture&orientation=landscape',
    author: '李雅文',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20casual%20attire%20on%20clean%20warm%20beige%20background%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20editorial%20headshot%20style&width=100&height=100&seq=author-li&orientation=squarish',
    date: '2026-07-15',
    readTime: '8分钟',
    tags: ['美食文化', '传统技艺', '餐饮创新', '文化传承'],
    featured: false,
  },
];

export const faqs = [
  {
    question: '精品一区二区的内容来源是什么？',
    answer: '精品一区二区的内容来自我们专业的编辑团队和签约作者，所有内容均经过严格审核和筛选，确保信息的准确性和内容的原创性。我们与多家优质内容机构合作，为用户提供多元化的高品质阅读体验。',
  },
  {
    question: '精品一区和精品二区有什么区别？',
    answer: '精品一区聚焦深度内容，涵盖科技前沿、商业洞察、人文思考等领域的专业文章，适合追求知识深度和专业见解的读者。精品二区聚焦生活美学，关注健康养生、旅行探索、美食文化、艺术设计等内容，为追求品质生活的读者提供灵感。',
  },
  {
    question: '如何订阅精品一区二区的更新通知？',
    answer: '您可以通过网站底部的 newsletter 订阅功能，输入邮箱地址即可免费订阅我们的内容更新通知。我们会每周精选优质内容推送到您的邮箱，让您不错过任何精彩文章。',
  },
  {
    question: '精品一区二区的内容是否免费？',
    answer: '精品一区二区的基础内容全部免费向用户开放。我们致力于让优质内容触达更多读者。部分深度专题和专栏内容可能需要注册会员后阅读，但我们始终保持大部分内容免费可访问。',
  },
  {
    question: '我可以投稿到精品一区二区吗？',
    answer: '当然可以！我们欢迎优质原创作者加入精品一区二区。您可以通过"关于我们"页面中的联系表单提交您的投稿意向，我们的编辑团队会在3个工作日内与您联系。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '周先生',
    role: '互联网企业高管',
    content: '精品一区二区是我每天必读的内容平台，一区的深度分析让我对行业趋势有了更清晰的认识，二区的生活内容也给我的日常生活带来很多灵感。',
    rating: 5,
  },
  {
    id: 2,
    name: '吴女士',
    role: '自由设计师',
    content: '特别喜欢精品二区的设计美学内容，每次阅读都能获取新的创作灵感。文章质量很高，排版也很舒服，阅读体验非常好。',
    rating: 5,
  },
  {
    id: 3,
    name: '郑先生',
    role: '高校教师',
    content: '精品一区的科技和人文内容质量很高，我经常把里面的文章推荐给学生作为课外阅读材料。内容深度和广度都令人满意。',
    rating: 5,
  },
  {
    id: 4,
    name: '孙女士',
    role: '健康管理师',
    content: '二区的健康养生内容专业且实用，不是那种泛泛而谈的鸡汤文，而是真正有科学依据和实操价值的干货内容。',
    rating: 4,
  },
];